'use client';

import { useCallback } from 'react';
import { toast } from 'sonner';
import { useTranslations } from 'next-intl';
import {
  getNotificationPreferences,
  updateNotificationPreferences,
} from '@/src/widgets/notifications/lib/notifications.api';

export function useArchiveWarningToast() {
  const t = useTranslations('postTaskModal.archiveWarning');

  const showIfNeeded = useCallback(async () => {
    try {
      const prefs = await getNotificationPreferences();
      if (prefs.suppressOrderArchiveWarning) return;

      toast(t('message'), {
        duration: Infinity,
        cancel: {
          label: t('ok'),
          onClick: () => {},
        },
        action: {
          label: t('dontShowAgain'),
          onClick: async () => {
            try {
              await updateNotificationPreferences({ suppressOrderArchiveWarning: true });
            } catch {
              // silent — toast already dismissed by Sonner
            }
          },
        },
      });
    } catch {
      // silent — don't block the order creation success flow
    }
  }, [t]);

  return { showIfNeeded };
}
